
import { FormData, FormFieldOption, FormFieldType, FormFieldValidation, FormPage, FormStructure } from '../../types/form';

// Define state and actions
export interface FormState {
  currentPage: number;
  formData: FormData;
  errors: Record<string, string>;
  isSubmitting: boolean;
  isSubmitted: boolean;
}

export type FormAction = 
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_FIELD'; payload: { name: string; value: string | string[] | boolean | File[] } }
  | { type: 'SET_ERROR'; payload: { name: string; error: string } }
  | { type: 'CLEAR_ERROR'; payload: string }
  | { type: 'LOAD_SAVED_DATA'; payload: Partial<FormState> }
  | { type: 'SUBMIT_START' }
  | { type: 'SUBMIT_SUCCESS' }
  | { type: 'SUBMIT_ERROR' };

export interface FormContextType extends FormState {
  nextPage: () => void;
  prevPage: () => void;
  setField: (name: string, value: string | string[] | boolean | File[]) => void;
  updateField: (name: string, value: string | string[] | boolean | File[]) => void; // Added updateField
  setError: (name: string, error: string) => void;
  clearError: (name: string) => void;
  submitForm: () => Promise<void>;
  formConfig: FormStructure;
  totalPages: number;
}

export const LOCAL_STORAGE_KEY = 'teaching_report_form_data';
